import type { DatabaseEngineId } from '@/core/engines';
import type { SqlSnippetTemplate } from './sqlSnippetTemplateTypes';
import { getBuiltInSqlSnippetTemplatesDmlSelect } from './builtInSqlSnippetTemplatesDmlSelect';
import { getBuiltInSqlSnippetTemplatesDmlWrite } from './builtInSqlSnippetTemplatesDmlWrite';

export function getBuiltInSqlSnippetTemplatesDml(engineId: DatabaseEngineId): readonly SqlSnippetTemplate[] {
  return [
    ...getBuiltInSqlSnippetTemplatesDmlSelect(engineId),
    ...getBuiltInSqlSnippetTemplatesDmlWrite(engineId),
  ] as const;
}
